import { PageBody, ResponsiveContainer } from "@ui/index";
import { PageWithHeaderAndFooter } from "@web/components/containers/PageWithHeaderAndFooter";
import { PostData } from "@web/types/blog/PostData";
import styles from "./css/BlogPage.module.css";
import { BlogPostTile } from "@web/pages/blog/BlogPostTile";
import { BlogHeader } from "@web/pages/blog/BlogHeader";

type Props = {
  allPostsData: Array<PostData>;
};

export function BlogPage({ allPostsData }: Props) {
  return (
    <PageWithHeaderAndFooter
      header={
        <div>
          <ResponsiveContainer>
            <BlogHeader />
          </ResponsiveContainer>
        </div>
      }
    >
      <PageBody header={undefined}>
        <div className={styles.grid}>
          {allPostsData.map((postData) => (
            <BlogPostTile key={postData.id} postData={postData} />
          ))}
        </div>
      </PageBody>
    </PageWithHeaderAndFooter>
  );
}
